<template>
  <div class="ellipsis-text">
    <tooltip
      :delay="500"
      :max-width="maxWidth"
      placement="top"
      :content="text"
      class="ellipsis-text-tooltip"
    >
      <div class="ellipsis-text-content" :style="{ width: maxWidth }">
        {{ text }}
      </div>
    </tooltip>
  </div>
</template>

<script>
export default {
  props: ['text', 'max-width']
}
</script>

<style lang="less">
.ellipsis-text {
  &-tooltip {
    width: 100%;
  }

  .ivu-tooltip-rel {
    display: flex;
  }

  &-content {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
